<template>
  <td-layout :config="config"></td-layout>
</template>
<script setup>
import config from './config'
import { useStore } from 'vuex'
import useUser from './composables/useUserInfo'
import { watchEffect } from 'vue'
const store = useStore()
const { userInfo, roleIds } = useUser()
import { intersection } from 'lodash'
watchEffect(() => {
  //第三方
  if (userInfo.value) {
    let password = store.state.app.framework.showToolsBar.find(e => e.name == 'password')
    let configShow = TdUI.getConfig('HEADER_SHOW_DROPDOWN_MENU')
    if (password) {
      if (userInfo.value.platform == 2) {
        //第三方的隐藏修改密码
        password.show = false
      }
      //自身
      if (userInfo.value.platform == 1) {
        //查看有没有配置 配置取配置文件的
        if (configShow) {
          password.show = configShow.split(',').includes('password')
        } else {
          //没有配置文件的默认全部显示
          password.show = true
        }
      }
    }
    //单位信息
    let unitother = store.state.app.framework.showToolsBar.find(e => e.name == 'unitother')
    if (unitother) {
      const PENALIZE_SHOW_ORG_ROLE = TdUI.getConfig('PENALIZE_SHOW_ORG_ROLE') || ''

      let s = intersection(PENALIZE_SHOW_ORG_ROLE.split(','), roleIds.value)
      if (configShow) {
        unitother.show = configShow.split(',').includes('unitother') ? s.length > 0 : false
      }
    }
  }
})
</script>
<style lang="scss">
.el-input-group__append {
  .overTimeCaptcha {
    height: 40px !important;
    line-height: 40px !important;
  }
}
</style>
